export const BRAND_KEYWORDS = [
  'Swarvinn Foods',
  'Swarvinn Impex',
  'swarvinnfoods.co.uk',
  'Swarvinn Foods UK',
  'Swarvinn Impex Ltd',
];

export const TRADE_KEYWORDS = [
  'Indian grocery export UK',
  'wholesale Indian food UK',
  'Indian rice supplier UK',
  'spices exporter India to UK',
  'Tamil Nadu food export',
  'Asian grocery wholesale UK',
  'cash and carry Indian food',
  'India to UK food import',
  'private label Indian food',
  'FSSAI certified export',
];

export const SITE_KEYWORDS = [...BRAND_KEYWORDS, ...TRADE_KEYWORDS].join(', ');

export const HOME_TITLE = 'Swarvinn Foods — Indian Grocery Export & Wholesale Supply to the UK';

export const HOME_DESCRIPTION =
  'Swarvinn Foods (Swarvinn Impex) exports wholesale Indian rice, spices, pulses, millets, flours and oils from Tamil Nadu. The United Kingdom is our main export country, with secondary markets in Europe, the UAE & Middle East, USA, Canada, Australia and Singapore.';
